/**
 * @generated SignedSource<<6b5b6369724921cbe25b5fab28edd5b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsListNavigationWithFilters_participativeModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsListFilters_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsListWithNavigationFragment_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "66b3cf83a58bcb0a9aaeb00fde915815";

module.exports = node;
